<template>
    <AppCard class="!shadow-sm mb-4">
        <div class="flex items-center border-b border-grey-200 pb-2">
            <UserAvatar class="mr-4" :user="review.user" :verified="review.verified"></UserAvatar>

            <div class="flex-grow">
                <div class="flex align-center">
                    <p class="mr-auto">{{ review.user.name }}</p>

                    <ReviewStarRating v-if="slimline" size="1x"
                                      :modelValue="review.rating"></ReviewStarRating>
                </div>

                <p v-if="!slimline || !review.product">
                    <FontAwesomeIcon :icon="['fal', 'pencil']"></FontAwesomeIcon>

                    {{ review.user.reviews_count }} review{{ review.user.reviews_count > 0 ? "s" : "" }}
                </p>

                <p v-else class="text-sm">
                    Reviewed
                    <span class="font-semibold">
                            <template v-if="review.product.brand">{{ review.product.brand.name }}</template>
                            {{ review.product.name }}
                        </span>
                </p>
            </div>
        </div>

        <div class="flex items-center mt-2" v-if="!slimline">
            <ReviewStarRating size="1x"
                              spacing="space-x-2"
                              :modelValue="review.rating"
                              class="mr-auto"></ReviewStarRating>

            <p class="text-sm">
                {{ reviewDate }}
            </p>
        </div>

        <h3 class="font-semibold mt-2" v-html="review.title"></h3>

        <p class="text-dark" v-html="reviewComment"></p>

        <template v-if="!slimline">
            <ReviewMetaLabel class="mt-2" label="Reviewing" v-if="review.product">
                <Link :href="route('products.show', review.product)">
                    <template v-if="review.product.brand">{{ review.product.brand.name }}</template>
                    {{ review.product.name }}
                </Link>
            </ReviewMetaLabel>

            <ReviewMetaLabel label="Size" v-if="review.tyre_detail && review.tyre_detail.size">
                {{ review.tyre_detail.size }}
            </ReviewMetaLabel>

            <ReviewMetaLabel label="Car Model"
                             v-if="review.tyre_detail && (review.tyre_detail.model && review.tyre_detail.model.manufacturer)">
                <Link :href="route('manufacturers.models.show', [review.tyre_detail.model.manufacturer, review.tyre_detail.model])">
                    {{ review.tyre_detail.model.manufacturer.name }} {{ review.tyre_detail.model.name }}
                </Link>
            </ReviewMetaLabel>

            <ReviewLikes :likes="review.likes"></ReviewLikes>
        </template>

        <p v-else class="text-sm mt-2 text-placeholder">{{ reviewDate }}</p>
    </AppCard>
</template>

<script>
import AppCard from "@/Components/AppCard";
import UserAvatar from "@/Components/Users/UserAvatar";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import ReviewStarRating from "@/Components/Reviews/ReviewStarRating";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import ReviewMetaLabel from "./ReviewMetaLabel";
import ReviewLikes from "./ReviewLikes";
import {Link} from "@inertiajs/inertia-vue3";

dayjs.extend(advancedFormat);

export default {
    components: {ReviewLikes, ReviewMetaLabel, ReviewStarRating, UserAvatar, AppCard, FontAwesomeIcon, Link},
    props: {
        review: Object,
        maxCommentLength: [String, Number],
        slimline: Boolean
    },
    computed: {
        reviewDate() {
            return dayjs(this.review.review_date).format("Do MMM YYYY");
        },
        reviewComment() {
            if (!this.maxCommentLength || this.review.comment.length < this.maxCommentLength) return this.review.comment;

            return this.review.comment.substring(0, this.maxCommentLength) + "...";
        }
    }
};
</script>

<style scoped>

</style>
